import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userServices from "../userAction";

const initialState = {
  notifications: [],
  loading: false,
  error: false,
  success: false,
  message: null,
};

export const userNotificationAction = createAsyncThunk(
  "userNotificationAction",
  () => {
    return userServices.getNotifications();
  }
);

export const markNotificationAsRead = createAsyncThunk(
  "markNotificationAsRead",
  async (notificationId) => {
    const res = await userServices.markNotificationAsRead(notificationId);
    if (res) {
      await userServices.getNotifications();
    }
  }
);

//CREATE THE SLICE

export const userStatDetailsSlice = createSlice({
  name: "userStatDetails",
  initialState,
  reducers: {
    //non asynchronous reducers goes here
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.message = "";
      state.notifications = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(userNotificationAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(userNotificationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.notifications = action.payload?.data?.data;
      })
      .addCase(userNotificationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.notifications = null;
      });
  },
});

export const { reset } = userStatDetailsSlice.actions;

export default userStatDetailsSlice.reducer;
